export default __webpack_public_path__ + "static/media/shield.60451ef9.svg";